if (!customElements.get('product-form')) {
	customElements.define('product-form', class AddToCart extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form[action$="/cart/add"]');
			this.productIdInput = this.form?.querySelector('[name=id]');
			this.addButtons = this.querySelectorAll('button[name="add"]');
			this.errorContainer = this.querySelector('.cart-item-error');
			this.stickyButton = document.querySelector('.js-sticky-add-to-cart');

			if (this.form && this.productIdInput) {
				this.productIdInput.disabled = false;
				this.form.addEventListener('submit', this.formSubmit.bind(this));
			}

			this.bindStickyButton();
		}

		bindStickyButton() {
			if (!this.stickyButton || !this.form) return;
			if (this.stickyButton.dataset.stickyBound === 'true') return;
			this.stickyButton.dataset.stickyBound = 'true';
			this.stickyButton.addEventListener('click', (event) => {
				event.preventDefault();
				this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
			});
		}

		async formSubmit(evt) {
			evt.preventDefault();

			if (!this.productIdInput?.value) {
				this.variantError();
				return;
			}

			this.removeErrorsBlock();
			this.toggleLoadingState(true);

			try {
				const config = {
					...fetchConfig('javascript'),
					body: new FormData(this.form)
				};

				config.headers = config.headers || {};
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const response = await fetch(`${window.routes.cart_add_url}`, config);
				const data = await response.json();

				if (data.status) {
					this.errorMessage(data);
					return;
				}
				this.success();
			} catch (error) {
				console.error('Add to cart error:', error);
				this.errorMessage({ status: 500, description: error.message || 'Unknown error' });
				this.toggleLoadingState(false);
			}
		}

		toggleLoadingState(isLoading) {
			this.addButtons?.forEach(button => {
				button.classList.toggle('loading', isLoading);
			});
		}

		errorMessage(resp) {
			if (resp.status === 422) {
				console.log("Error Response:", resp);

				if (this.errorContainer) {
					const message = resp.description || resp.message || 'Error adding to cart';
					this.errorContainer.innerHTML = message;
					this.errorContainer.style.display = 'block';
				}
				else if (this.closest('.global-error-container')) {
					let errorBlock = document.createElement('p');
					errorBlock.classList.add('product-error');
					errorBlock.innerHTML = resp.message || resp.description;
					this.closest('.global-error-container').prepend(errorBlock);
				}

				this.success();
			}

			this.toggleLoadingState(false);
		}

		success() {
			console.log("Product added to cart");
			this.toggleLoadingState(false);

			if (typeof updateCartCount === 'function') updateCartCount();
			if (typeof updateCartPopup === 'function') updateCartPopup();

			if(document.querySelector('#choose-option-popup')){
				document.querySelector('#choose-option-popup').classList.remove('open');
				document.querySelector('#choose-option-popup').classList.remove('animation');
			}

			if (!document.querySelector('.js-cart-page')) {
				this.openCartPopup();
			}

			if(document.querySelector('.js-cart-page cart-item')){
				document.querySelector('.js-cart-page').classList.add('loading');
				document.querySelector('.js-cart-page cart-item').updateCartContent();
			} else if(document.querySelector('.js-cart-page')){
				window.location.reload();
			}
		}

		variantError() {
			console.error('Product variant not selected');
			if (this.errorContainer) {
				this.errorContainer.innerHTML = 'Please select a variant';
				this.errorContainer.style.display = 'block';
			}
		}

		removeErrorsBlock() {
			if (this.errorContainer) {
				this.errorContainer.innerHTML = '';
				this.errorContainer.style.display = 'none';
			}
			document.querySelector('.product-error')?.remove();
		}

		openCartPopup(){
			const cartPopup = document.querySelector('#popup-cart');
			if (!cartPopup) return;
			cartPopup.classList.add('open');
			setTimeout(function () {
				cartPopup.classList.add('animation');
			}, 200);
		}
	});
}